import Repository from '../Repository';
import { GroupHasReportsError } from '../user/erros';

export default {
  getContextualGroups(token) {
    return Repository.get('/administer/contextgroups', {
      headers: {
        Authorization: token,
      },
    })
      .then(response => this.remapObjectResponse(response.data))
      .catch((e) => {
        console.log(e);
      });
  },
  getAllGroupsIndexes(token) {
    return Repository.get('/administer/groups', {
      headers: {
        Authorization: token,
      },
    })
      .then(response => this.remapArrayResponse(response.data))
      .catch((e) => {
        console.log(e);
      });
  },
  getAllGroups(token) {
    return Repository.get('/administer/groups', {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data).catch((e) => {
      console.log(e);
    });
  },
  crudGroups(token, groups) {
    return Repository.post('/administer/groups', groups, {
      headers: {
        Authorization: token,
      },
    }).then(response => response).catch((e) => {
      if (e.response.status === 400) {
        if (e.response.data.code === 'GROUP_ASSIGNED_FOR_REPORT') {
          throw new GroupHasReportsError(e.response.data.message);
        }
      }
      console.log(e);
    });
  },
  getGroupAvailableShops(token, groupID) {
    return Repository.get(`/administer/groups/${groupID}/shops`, {
      headers: {
        Authorization: token,
      },
    }).then(response => this.remapObjectResponse(response.data)).catch((e) => {
      console.log(e);
    });
  },
  remapArrayResponse(input) {
    const mappedOutput = [];
    input.forEach((v, k) => {
      mappedOutput[k] = {
        id: v.id,
        name: v.name,
      };
    });
    return mappedOutput;
  },
  remapObjectResponse(input) {
    return Object.keys(input)
      .map(key => ({
        id: Number(key),
        name: input[key],
      }));
  },

  getContextualGroupsMockup() {
    return this.remapObjectResponse({
      1: 'Demo 1',
      2: 'Demo 2',
    });
  },
  getAllGroupsMockup() {
    return [{
      id: 1,
      name: 'Demo 1',
      shops: [
        {
          id: 1,
          name: 'rasbery pi',
        },
        {
          id: 2,
          name: 'Salon Demo 2',
        },
        {
          id: 3,
          name: 'Sala konferencyjna',
        },
        {
          id: 7,
          name: 'nowy salon',
        },
      ],
      detachShopIds: null,
    }, {
      id: 2,
      name: 'Demo 2',
      shops: [
        {
          id: 1,
          name: 'rasbery pi',
        },
      ],
      detachShopIds: null,
    }];
  },
  getGroupAvailableShopsMockup(groupID) {
    if (groupID === 1) {
      return this.remapObjectResponse({});
    }
    return this.remapObjectResponse({
      3: 'Sala konferencyjna',
      2: 'Salon Demo 2',
    });
  },

};
